(function () {
    'use strict';
    var m = angular.module('app', [
        'ngRoute',
        'ngCookies',
        'utils',
        'ui.slimscroll',
        'auth',
        'dashboard',
        'profiles',
        'app-store',
        'policy',
        'monospaced.mousewheel',
        'dao',
        'user-management',
        'ngSanitize',
        'viewer',
        'security-stack',
        'angular-data.DSCacheFactory',
        'report',
        'settings',
        'advanced-data-search',
        'wizard',
        'templates',
        'alerts',
        'configuration',
        'quarantine',
        'troubleshooting',
        'scan-monitor',
        'devices',
        'email-report',
        'gui-v2'
    ], ["$rootScopeProvider", function ($rootScopeProvider) {
        $rootScopeProvider.digestTtl(20);
    }]);
    m.config(["$locationProvider", "$httpProvider", "$compileProvider", "resolverManagerProvider", "routerV1ServiceProvider", "routerV2ServiceProvider", "$qProvider", function ($locationProvider, $httpProvider, $compileProvider, resolverManagerProvider, routerV1ServiceProvider, routerV2ServiceProvider, $qProvider) {
        var utils = {
            htmlTitle: function (text) {
                return '#' + JSON.stringify({
                    display: 'html',
                    text: text
                });
            },
            templatePath: function (moduleName, controllerName, templateName) {
                return '/assets/' + moduleName + '/controllers/' + controllerName + '/' + (templateName || controllerName) + '.html';
            },
            title: function (text) {
                return utils.htmlTitle('<strong>' + text + '</strong>');
            }
        };
        var resolvers = {
            featureResolver: resolverManagerProvider.featureResolver,
            userNotExist: resolverManagerProvider.userNotExist,
            currentUser: resolverManagerProvider.currentUser
        };
        routerV2ServiceProvider.specials();
        if (window.guiVersion === 1) {
            routerV1ServiceProvider.routers(utils, resolvers);
        } else if (window.guiVersion === 2) {
            routerV2ServiceProvider.routers(utils, resolvers);
        }
        $locationProvider.html5Mode(false);
        $locationProvider.hashPrefix('!');
        //initialize get if not there
        if (!$httpProvider.defaults.headers.get) {
            $httpProvider.defaults.headers.get = {};
        }
        //disable IE ajax request caching
        $httpProvider.defaults.headers.get['If-Modified-Since'] = '0';
        //TODO should be true on dev and false on production
        $compileProvider.debugInfoEnabled(true);
        // show/hide js unhandled promise errors on browser console
        $qProvider.errorOnUnhandledRejections(localStorage.getItem('show-js-errors') === '1');
    }]);
    m.run(["$window", "$http", "DSCacheFactory", "$location", "$route", "$rootScope", "docTitleHelper", "underscoreMixins", function ($window, $http, DSCacheFactory, $location, $route, $rootScope, docTitleHelper, underscoreMixins) {
        var original = $location.path;
        $location.path = function (path, reload) {
            if (_(reload).isUndefined()) {
                reload = true;
            }
            if (reload === false) {
                var lastRoute = $route.current;
                var un = $rootScope.$on('$locationChangeSuccess', function () {
                    $route.current = lastRoute;
                    un();
                });
            }
            return original.apply($location, [path]);
        };
        DSCacheFactory('defaultCache', {
            maxAge: 1000,
            // Items added to this cache expire after 15 minutes.
            deleteOnExpire: 'aggressive'    // Items will be deleted from this cache right when they expire.
        });
        $http.defaults.cache = DSCacheFactory.get('defaultCache');
        underscoreMixins.addMixins();
    }]);
}());